<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- begin  -->
    <v-card class="box" ref="selectedCard">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Mark Inward </strong>
        </v-toolbar-title>
      </v-toolbar>
      <!-- <div style="margin-left: 35%"> -->
      <v-row dense>
        <v-col cols="12" sm="2" md="2"></v-col>
        <v-col cols="12" sm="4" md="4">
          <!-- new    -->
          <v-col cols="12" sm="12" md="12">
            <p><b>Outward No</b></p>

            <v-text-field outlined dense type="text" v-model="outward_no"></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <p><v-icon color="error">*</v-icon><b>Sender</b></p>
            <v-autocomplete color="#0F2027" dense rounded required v-model="sender" :items="sender_list"
              item-text="name" return-object label="Sender" outlined persistent-hint hint="Please Select Sender" />
          </v-col>
          <!-- new end -->
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <!-- new -->
          <v-col cols="12" sm="12" md="12">
            <p><v-icon color="error">*</v-icon><b>Description</b></p>
            <v-textarea auto-grow outlined rows="7" name="input-7-4" v-model="description"
              label="Enter Description"></v-textarea>
          </v-col>
          <!-- new end -->
        </v-col>
        <v-col cols="12" sm="2" md="2"></v-col>
      </v-row>
      <!-- <v-col cols="12" sm="4" md="4">
        <p><b>Outward No</b></p>

        <v-text-field
          outlined
          dense
          type="text"
          v-model="outward_no"
        ></v-text-field>
      </v-col> -->

      <!-- <v-col cols="12" sm="4" md="4">
        <p><v-icon color="error">*</v-icon><b>Sender</b></p>
        <v-autocomplete
          color="#0F2027"
          dense
          rounded
          required
          v-model="sender"
          :items="sender_list"
          item-text="name"
          return-object
          label="Sender"
          outlined
          persistent-hint
          hint="Please Select Sender"
        />
      </v-col> -->
      <!-- <v-col cols="12" sm="6" md="6">
        <p><v-icon color="error">*</v-icon><b>Description</b></p>
        <v-textarea
          outlined
          name="input-7-4"
          v-model="description"
          label="Enter Description"
        ></v-textarea>
      </v-col> -->
      <v-row dense>
        <v-col cols="12" sm="2" md="2"></v-col>
        <v-col cols="12" sm="4" md="4">
          <p><v-icon color="error">*</v-icon><b>Receiver</b></p>

          <v-text-field outlined dense type="text" v-model="receiver_instructor"></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <p><v-icon color="error"></v-icon><b>Copy To Receiver</b></p>
          <v-autocomplete color="#0F2027" dense rounded v-model="receiver_instructor" :items="receiver_instructor_list"
            item-text="inst_name" item-value="inst_name" label="Receiver Instructor" outlined persistent-hint
            hint="Please Select Receiver Instructor" />
        </v-col>
        <v-col cols="12" sm="2" md="2"></v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" sm="2" md="2"></v-col>
        <v-col cols="12" sm="4" md="4">
          <p><v-icon color="error">*</v-icon><b>Handover To</b></p>

          <v-text-field outlined dense type="text" v-model="handover_instructor"></v-text-field>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <p><v-icon color="error"></v-icon><b>Copy To Handover</b></p>
          <v-autocomplete color="#0F2027" dense rounded v-model="handover_instructor" :items="handover_instructor_list"
            item-text="inst_name" item-value="inst_name" label="Handover Instructor" outlined persistent-hint
            hint="Please Select Handover Instructor" />
        </v-col>
        <v-col cols="12" sm="2" md="2"></v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="4">
          <v-text-field label="Date" rounded outlined dense type="date" v-model="inward_date"></v-text-field>
        </v-col>
      </v-row>
      <!-- </div> -->
      <v-row justify="center" dense>
        <v-col cols="12" sm="1" md="1"></v-col>
        <v-col col="12" sm="2" md="2">
          <v-btn class="button" :disabled="isSaveButtonDisabled" @click="saveinward()">{{ save_edit }}</v-btn>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="box">
      <!-- excel export btn code -->
      <v-row dense>
        <v-col cols="12" sm="4" md="4" v-if="inward_outward_list.length != 0">
          <v-btn color="success" outlined rounded>
            <download-excel class="mr-2 pb-3 pt-2" :data="inward_outward_list" :fields="table_fields"
              worksheet="InwardReport" name="InwardReport.xls">
              <v-icon dark>mdi-file-excel</v-icon> Export
            </download-excel>
          </v-btn>
        </v-col>
        <v-col cols="12" sm="4" md="4">
          <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-col>
      </v-row>
      <!-- excel export btn code end -->
      <v-data-table :headers="headers" :items="inward_outward_list" :search="search" disable-sort="true"
        class="mytable1">
        <!-- <v-data-table :headers="headers"> -->
        <template v-slot:top>
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Inward Report</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <div v-if="item.filejourneytype == 'Inward'">
            <v-avatar size="25" class="edit-avatar">
              <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
            </v-avatar>
            <v-avatar size="35">
              <v-icon class="mr-4 v-icon-size" color="red" title="delete"
                @click="deletePlanData(item)">mdi-trash-can</v-icon>
            </v-avatar>
          </div>
          <div v-else>
            <v-avatar size="25" class="edit-avatar">
              <v-icon class="mr-2 edit-v-icon" @click="mark_return(item)"
                title="mark inward for the selected outward">mdi-redo-variant</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },
  data: () => ({
    snackbar_msg: "",
    // extraBreadcrumbItems: [


    // ],
    // breadcrumbClass: "breadcrumb-style1",

    color: "",
    snackbar: false,
    overlay: false,
    inward_date:new Date().toISOString().slice(0, 10),
    description: "",
    outward_no: "",
    receiver_instructor: "",
    handover_instructor: "",
    sender: "",
    // receiver: "",
    sender_list: [],
    handover_instructor_list: [],
    receiver_instructor_list: [],
    search: "",
    headers: [
      { text: "Sr. No", value: "srno" },
      { text: "Journey Type", value: "filejourneytype" },
      { text: "Inward No", value: "inward_no" },
      { text: "Outward No", value: "outward_no" },
      { text: "Date", value: "iodate", width: "8%" },
      { text: "Sender", value: "sender.name" },
      { text: "I-Receiver", value: "receiver" },
      { text: "O-Receiver", value: "outwardreceiver.name" },
      { text: "Handover To", value: "handoverto" },
      { text: "Description", value: "description" },
      //   { text: "Address", value: "address" },
      { text: "Action", value: "action" },
    ],
    table_fields: {
      "Sr. No": "srno",
      "Journey Type": "filejourneytype",
      "Inward No": "inward_no",
      "Outward No": "outward_no",
      Date: "iodate",
      Sender: "sender.name",
      "I-Receiver": "receiver",
      "O-Receiver": "outwardreceiver.name",
      "Handover To": "handoverto",
      Description: "description",
    },
    inward_outward_list: [],
    save_edit: "Save",
    edit_io_id: null,
    ///////////////////////////////////////////////
  }),
  mounted() {
    this.onload();
  },

  computed: {
    isSaveButtonDisabled() {
      return !(
        this.description &&
        this.sender &&
        this.receiver_instructor &&
        this.handover_instructor
      );
    },
  },

  methods: {
    onload() {
      this.save_edit = "Save";
      axios
        .post("/inwardOutward/inward")
        .then((res) => {
          if (res.data.flag == "YES") {
            console.log("inward_outward_list", res.data.inward_outward_list);
            this.sender_list = res.data.sender;
            this.handover_instructor_list = res.data.inst_list;
            this.receiver_instructor_list = res.data.inst_list;
            this.inward_outward_list = res.data.inward_outward_list;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    saveinward() {
      const formdata = {
        edit_io_id: this.edit_io_id,
        senderid: this.sender.id,
        receiver: this.receiver_instructor,
        handoverto: this.handover_instructor,
        description: this.description,
        save_edit: this.save_edit,
        outward_no: this.outward_no,
        inward_date:this.inward_date
      };
      console.log("out no", this.outward_no);
      axios
        .post("/inwardOutward/saveinward", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            //this.outward_list = res.data.outward_list
            console.log("io", res.data.io);
            this.showSnackbar("green", res.data.snackbar);
            //this.outward_list.splice(0, 0, res.data.io);
            this.reset();
            this.onload();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          console.log(error);
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
      //   this.overlay = true;
    },
    reset() {
      this.save_edit = "Save";
      this.edit_io_id = null;
      this.outward_no = "";
      this.sender = "";
      this.receiver_instructor = "";
      this.handover_instructor = "";
      this.description = "";
      this.address = "";
    },
    editItem(item) {
      //   this.editRecord.title = item.title;
      //   this.editRecord.description = item.description;
      //   this.editRecord.id = item.id;
      //   this.edit_dialog = true;
      // this.$vuetify.goTo(0); // for scrolling top
      this.$vuetify.goTo(this.$refs.selectedCard); // for scrolling up

      this.save_edit = "Edit";
      this.edit_io_id = item.id;
      this.sender = item.sender;
      this.receiver_instructor = item.receiver;
      this.handover_instructor = item.handoverto;
      this.description = item.description;
      this.inward_date = item.iodateEdit
    },
    mark_return(item) {
      // this.$vuetify.goTo(0); // for scrolling up
      this.$vuetify.goTo(this.$refs.selectedCard); // for scrolling up

      this.save_edit = "Save";
      this.description = item.description;
      this.outward_no = item.outward_no;
    },
    deletePlanData(item) {
      const formdata = {
        delete_io_id: item.id,
        name: "Inward",
      };
      axios
        .post("/inwardOutward/deleteinwardoutward", formdata)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", res.data.snackbar);
            this.onload();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          console.log(error);
          this.onerror(error);
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
  },
};
</script>

<style scoped>
.v-data-table ::v-deep th {
  font-size: 14px !important;
  font-weight: 800 !important;
}
/* .v-data-table ::v-deep td {
  font-size: 16px !important;
} */
</style>
